import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from './Link.jsx';
import buttonStyle from '../styles/buttonStyle.js';
import styles from '../styles/styles.js';
import Dialog from './Dialog.jsx';
import DialogTitle from './DialogTitle.jsx';
import DialogContent from './DialogContent.jsx';
import DialogActions from './DialogActions.jsx';

const ConfirmationAlert = (props) => {
  const classes = useStyles();
  const {
    // type,
    title,
    titleClass,
    body,
    visible,
    noContent,
    yesContent,
    yesAriaLabel,
    noAriaLabel,
    onNo,
    onYes,
    showButtons,
    // showConfirm,
    customNoBtnClass,
    customYesBtnClass,
    bodyTestId,
    buttonsTestId,
  } = props;


  if (!visible) {
    return null;
  }

  return (
    <Dialog
      //   type={ type }
      aria-describedby={'alert-title'}
      open={visible}
      disableEscapeKeyDown={true}
      aria-labelledby={'alert-body'}
      role='dialog'
      aria-modal='true'
      className={classes.alertCard}
      fullWidth={true}
      maxWidth={'xs'}
      classes={{paper: classes.paper}}>
      {title &&
        <DialogTitle
          id={'alert-title'}
          className={ classNames(classes.title, titleClass) }>
          { title }
        </DialogTitle>
      }
      <DialogContent
        data-testid={bodyTestId}
        className={classes.contentContainer}
        id={'alert-body'}>
        { body }
      </DialogContent>
      {(onYes && onNo && yesContent && noContent) &&
        <DialogActions className={classes.actionsContainer}>
          {showButtons &&
            <div data-testid={buttonsTestId}>
              <Link
                role='button'
                tabIndex={0}
                onClick={ onNo }
                underline='none'
                aria-label={noAriaLabel}
                className={ customNoBtnClass }>
                { noContent }
              </Link>
              <Link
                autoFocus
                role='button'
                tabIndex={0}
                onClick={ onYes }
                underline='none'
                aria-label={yesAriaLabel}
                className={ customYesBtnClass }>
                { yesContent }
              </Link>
            </div>
          }
        </DialogActions>
      }
    </Dialog>
  );
};

ConfirmationAlert.propTypes = {
  type: PropTypes.oneOf([
    'default', 'secondary', 'info', 'success', 'warning',
    'danger', 'error', 'input', 'custom', 'controlled',
  ]).isRequired,
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string,
  titleClass: PropTypes.string,
  body: PropTypes.node,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  yesContent: PropTypes.string,
  noContent: PropTypes.string,
  yesAriaLabel: PropTypes.string,
  noAriaLabel: PropTypes.string,
  showButtons: PropTypes.bool,
  showConfirm: PropTypes.bool,
  customYesBtnClass: PropTypes.string,
  customNoBtnClass: PropTypes.string,
  bodyTestId: PropTypes.string,
  buttonsTestId: PropTypes.string,
};

ConfirmationAlert.defaultProps = {
  onNo: () => {},
  onYes: () => {},
  showButtons: true,
  // showConfirm: false,
  title: null,
  body: '',
  type: 'default',
};

const useStyles = styles.makeStyles(
    () => {
      return {
        ...buttonStyle,
        contentContainer: {
          zIndex: 1,
          justifyContent: 'center',
          margin: 0,
          padding: 0,
          fontSize: '1.125em',
          fontWeight: 300,
          lineHeight: 'normal',
          textAlign: 'center',
          wordWrap: 'break-word',
        },
        actionsContainer: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          margin: '1.25em auto 0',
          zIndex: 1,
          flexWrap: 'wrap',
        },
        title: {
          textAlign: 'center',
        },
        paper: {
          padding: '1.25rem',
          maxWidth: 454,
        },
      };
    });

export default ConfirmationAlert;
